import { useMutation } from '@tanstack/react-query';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const toggleSubscriptionPlan = async (id: string, active: boolean) => {
  const res = await apiManager.patch(`subscription-plan/admin/edit/${id}`, { active });
  return res;
};

export const useToggleSubscriptionPlan = () =>
  useMutation({
    mutationFn: async ({ id, active }: { id: string; active: boolean }) => {
      const res = await apiClient.patch(ENDPOINTS.SUBSCRIPTION_PLANS.TOGGLE_SUBSCRIPTION(id), { active });
      return res.data;
    },
  });
